import { Directive, EventEmitter, HostListener, Output } from "@angular/core";

@Directive({
    selector: '[hover]'
})
export class HoverDirective {
    @Output() hover: EventEmitter<boolean> = new EventEmitter<boolean>()
    

    @HostListener('mouseenter', ['$event'])
    public onHoverIn(e: any) {
        e.preventDefault();
        this.hover.emit(true);
    }

    @HostListener('mouseleave', ['$event'])
    public onHoverOut(e: any) {
        e.preventDefault();
        this.hover.emit(false);
    }   
}